import React from 'react';

export const MailIcon = () => {
  return (
    <svg
      width="100%"
      height="100%"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M0 3V17H20V3H0ZM18 7L10 12L2 7V5L10 10L18 5V7Z"
        fill="white"
      />
    </svg>
  );
};
